<template>
    <modal
    name="admin-modal-survey"
    height="auto"
    width="70%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">
      <div class="row7">
        <header class="modalHeader flex flexAlignS">
          <p>{{mode === 'REG' ? '설문지 등록' : '설문지 수정'}}</p>
          <button @click="onClickCancel"></button>
        </header>
        <div class="topContents flex flexAlignS">
          <div class="flex">
            <div class="surveyInputBox flex">
                <label>구분</label>
                <div class="surveySelectBox">
                    <b-form-select v-model="survey.target" :options="targetOptions" ></b-form-select>
                </div>
            </div>
            <div class="surveyInputBox flex mgCustom">
                <label>상태</label>
                <div class="bspRadio surveyCustom">
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="status"
                            :options="statusOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radios-btn-default"
                            buttons
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
            </div>
          </div>

          <div class="surveyFormSelect flex">
              <label>설문지 양식</label>
              <button @click="isShowItemDrop = !isShowItemDrop" class="fixedPlusBtn">
                  <span>+</span>
              </button>
              <transition class="profileDrop" name="fade">
                <div v-if="isShowItemDrop" class="dropBox">
                  <ul>
                    <li @click="onClickAddItem('SHORT')">단답형</li>
                    <li @click="onClickAddItem('MULTIPLE')">객관식</li>
                    <li @click="onClickAddItem('CHECK')">체크박스</li>
                    <li @click="onClickAddItem('LINEAR')">선형</li>
                  </ul>
                </div>
              </transition>
          </div>
        </div>

        <div class="inner">
            <div class="introductionTxt">
                <section class="surveyArea adminSurbeyBox">
                    <div class="titleInput">
                        <div>
                          <p>
                              설문지 제목
                          </p>
                          <input v-model="survey.title" placeholder="제목을 입력하세요." maxlength="85"/>
                        </div>
                        <div>
                          <p>
                              설문지 상세 설명
                          </p>
                          <input v-model="survey.introduction" placeholder="내용을 입력하세요." maxlength="170"/>
                        </div>
                    </div>
                    <component 
                      v-for="item in survey.items" 
                      :key="item.order"
                      :is="bindComponent(item)"
                      v-bind:item="item"
                      @onClickDeleteItem="onClickDeleteItem">
                    </component>
                </section>
            </div>
        </div>

        <div>
          <div class="surveyInputBox flex">
            <label>종료일</label>
            <div class="btDatePicker">
              <b-form-datepicker 
              v-model="survey.endDate" 
              :disabled="isIndefinite"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }">
              </b-form-datepicker>
            </div>
            <div class="checkBoxForm">
              <b-form-checkbox class="termCheckBox" v-model="isIndefinite" @change="(checked)=>{if(checked) survey.endDate = ''}">무기한</b-form-checkbox>
            </div>
            <div class="btnBox">
              <button v-if="mode !== 'REG' && (oldStatus === 'ONGOING' || status === 'ONGOING')" class="smallBtn" @click="onClickDateSave">날짜변경</button>
            </div>
          </div>
        </div>

        <div class="modalFooterBtn btnBox">
          <button class="redBtn" @click="onClickSave" v-if="oldStatus == STATUS.STANDBY">{{mode === 'REG' ? '등록' : '수정'}}</button>
          <!-- <button v-if="mode === 'REG'" class="redBtn" @click="onClickSave" :disabled="oldStatus != STATUS.STANDBY">등록</button>
          <button v-else-if="mode !== 'REG' && (oldStatus !== 'ONGOING' || status !== 'ONGOING')" class="redBtn" @click="onClickSave">수정</button> -->
          <button class="redborderBtn" @click="onClickCancel">취소</button>
        </div>
        
      </div>
    </modal>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import Short from './Short.vue'
import Multiple from './Multiple.vue'
import Check from './Check.vue'
import Linear from './Linear.vue'
import {STATUS} from '@/data/survey'
import * as surveyUtil from '@/utils/surveyUtil'
import * as validationUtil from '@/utils/validationUtil'

export default {
  name: 'AdminModalSurvey',
  components:{
    Short,
    Multiple,
    Check,
    Linear
  },
  props:[
    'surveyIdx'
  ],
  data(){
    return{
      modalResult: false,
      oldSurvey: null,
      oldStatus: STATUS.STANDBY,
      STATUS: STATUS,
      targetOptions: [
        { value: '', text: '선 택' },
        { value: 'USER', text: '개인' },
        { value: 'CORP', text: '기업' },
        { value: 'ALL', text: '모두' }
      ],
      status: STATUS.STANDBY,
      statusOptions: [
          { text: '대기', value: STATUS.STANDBY },
          { text: '시작', value: STATUS.ONGOING },
      ],
      isShowItemDrop: false,
      isIndefinite: false,
    }
  },
  computed:{
    ...mapState('survey', [
      'survey'
    ]),
    mode(){
      if(validationUtil.isEmpty(this.surveyIdx)){
        return 'REG'
      }
      else{
        return 'MOD'
      }
    }
  },
  mounted(){
    this.show()
  },
  methods:{
    ...mapMutations('survey', [
      'resetSurvey',
      'addItem',
      'deleteItem'
    ]),
    ...mapActions('survey', [
      'requestDetail',
      'saveSurvey',
      'updateDateSurvey'
    ]),
    show(){
      this.$modal.show('admin-modal-survey')
    },
    hide(){
      this.$modal.hide('admin-modal-survey')
    },
    beforeOpen(){
      this.init()
    },
    closed(){
      this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
    },
    init(){
      this.resetSurvey()

      if(validationUtil.isEmpty(this.surveyIdx)){
        // [등록]
        return
      }
      
      const surveyIdx = Number(this.surveyIdx)

      this.requestDetail({
        surveyIdx: surveyIdx
      })
      .then(() => {
        this.status = surveyUtil.getStatus(this.survey.startDate, this.survey.endDate)
        if(this.survey.endDate == null){
          this.isIndefinite = true
        }

        // 원본 데이터 저장
        this.oldSurvey = this.lodash.cloneDeep(this.survey)
        this.oldStatus = this.status
      })
      .catch(() => {
        this.$alert('알림', '데이터를 가져올 수 없습니다.', '확인', {
          'closed': () => {
            this.hide()  
          }
        })
      })
    },
    bindComponent(item){
      switch(item.type){
        case 'SHORT':
          return Short
        case 'MULTIPLE':
          return Multiple
        case 'CHECK':
          return Check
        case 'LINEAR':
          return Linear
        default:
          return null
      }
    },
    onClickAddItem(type){
      this.addItem({
        type: type,
        order: this.survey.items.length+1
      }) 
    },
    onClickDeleteItem(index){
      this.deleteItem(index)
    },
    doSave(){
      this.saveSurvey({ 
        jsonString: JSON.stringify(this.survey),
        isStart: this.status === STATUS.ONGOING ? true : false
      })
      .then(response => {
        var data = response.data
        if(data.RESULT == true){
          this.$alert('알림', '저장되었습니다.', null, {
            'closed': () => {
              this.modalResult = true
              this.hide()
            }
          })
        }
        else{
          this.$alert('알림', '데이터 저장을 실패했습니다. ERROR: '+data.ERROR)
        }
      })
      .catch(() => {
        this.$alert('알림', '요청을 실패했습니다.')
      })
    },
    onClickSave(){
      if(!validationUtil.isEmpty(this.surveyIdx) && 
      !validationUtil.isEmpty(this.oldSurvey) &&
      !validationUtil.isEmpty(this.oldStatus)){
        // [수정] 변경사항이 없는 경우 무시
        if(JSON.stringify(this.survey) === JSON.stringify(this.oldSurvey) &&
        this.status === this.oldStatus) {
          this.$alert('알림', '변경사항이 없습니다.')  
          return
        }
      }

      if(validationUtil.isEmpty(this.survey.target)){
        this.$alert('알림', '구분 값을 선택해주세요.')
        return
      }

      if(this.isIndefinite == false && validationUtil.isEmpty(this.survey.endDate)){
        this.$alert('알림', '종료일을 선택해주세요.')
        return
      }

      if(this.survey.title === ''){
        this.$alert('알림', '설문 제목을 입력해주세요.')
        return
      }

      if(this.survey.items == null || this.survey.items.length == 0){
        this.$alert('알림', '저장될 설문 항목이 없습니다.')
        return
      }

      for(let i in this.survey.items){
        const item = this.survey.items[i]
        if(item.question === ''){
          this.$alert('알림', item.order + '번 항목의 질문을 입력해주세요.')
          return
        }

        if(item.type !== "SHORT"){
          const options = item.options
          if(options == null || options.length == 0){
            this.$alert('알림', '단답형을 제외한 설문 항목에는 한 개 이상의 옵션이 필요합니다.('+item.order+'번 항목)')
            return
          }

          if(item.type !== "LINEAR"){
            for(let j in options){
              const option = options[j]
              if(option.data === ''){
                this.$alert('알림', item.order+'번 항목 '+option.order + '번 옵션의 내용을 입력해주세요.')
                return
              }
            }
          }
        }
      }

      if(this.status === STATUS.ONGOING){
        var response = this.$createConfirmResponse()

        this.$confirm('알림', '설문 시작 후 수정할 수 없습니다. 등록하시겠습니까?' , '확인', '취소', response, {
          'closed': ()=>{
            if(response.result == true){
              this.doSave()
            }
          }
        })
      }
      else{
        this.doSave()
      }

      
    },
    onClickCancel(){
      this.hide()
    },
    onClickDateSave(){
      this.updateDateSurvey({ 
        jsonString: JSON.stringify(this.survey),
        isStart: this.status === STATUS.ONGOING ? true : false
      })
      .then(response => {
        var data = response.data
        if(data.RESULT == true){
          this.$alert('알림', '날짜가 변경되었습니다.', null, {
            'closed': () => {
              this.modalResult = true
              this.hide()
            }
          })
        }
        else{
          this.$alert('알림', '데이터 저장을 실패했습니다. ERROR: '+data.ERROR)
        }
      })
      .catch(() => {
        this.$alert('알림', '요청을 실패했습니다.')
      })
    },
  }
}
</script>

<style scoped lang="scss">
    .bspRadio ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
    .bspSelectBox ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
    .btDatePicker ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
    .checkBoxForm ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
</style>
